module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "forgot-email-password"
    }
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t('email')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'danger-border': _vm.emailError && _vm.showError.email
    },
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "placeholder": _vm.$t('email')
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendEmail($event)
      },
      "blur": [function($event) {
        _vm.showError.email = true
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [(_vm.errors.has('email') && _vm.showError.email) ? _c('span', [_vm._v(_vm._s(_vm.errors.first('email')))]) : (_vm.showError.email) ? _c('span', [_vm._v(_vm._s(_vm.emailErrorMsg))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "sendEmail"
    }
  }, [_c('label', {
    attrs: {
      "for": "verificationCode"
    }
  }, [_vm._v(_vm._s(_vm.$t('yourCode')))]), _vm._v(" "), (_vm.time > 0) ? _c('span', {
    staticClass: "send-email wait"
  }, [_vm._v(_vm._s(_vm.$t('sent')) + " " + _vm._s(_vm.time) + " s")]) : _c('span', {
    staticClass: "send-email",
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v(_vm._s(_vm.$t('sendEmail')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.verificationCode),
      expression: "verificationCode",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|digits: 5'),
      expression: "'required|numeric|digits: 5'"
    }],
    class: {
      'danger-border': _vm.verificationCodeError && _vm.showError.verificationCode
    },
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "verificationCode",
      "id": "verificationCode",
      "placeholder": _vm.$t('yourCode')
    },
    domProps: {
      "value": (_vm.verificationCode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.verifyEmailAndCode($event)
      },
      "blur": [function($event) {
        _vm.showError.verificationCode = true
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verificationCode = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [(_vm.errors.has('verificationCode') && _vm.showError.verificationCode) ? _c('span', [_vm._v(_vm._s(_vm.errors.first('verificationCode')))]) : (_vm.showError.verificationCode) ? _c('span', [_vm._v(_vm._s(_vm.verificationCodeErrorMsg))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-bottom"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "form-submit line-button",
    on: {
      "click": _vm.verifyEmailAndCode
    }
  }, [_vm._v(_vm._s(_vm.$t('next')))]), _vm._v(" "), _c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.loading
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "resetModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-close"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('resetPassword')))]), _vm._v(" "), _c('p', {
    staticClass: "email"
  }, [_vm._v(_vm._s(_vm.email))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('sendToprompt')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "form-submit",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('confirm')))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a66a1f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/forgotpwd/forgotEmailPwd/ForgotEmailPwd.vue
// module id = 1345
// module chunks = 1